import React from 'react';
import { MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const VIVATECH_BANNER_END_ISO = '2026-06-20T23:59:59+02:00';

export function isVivatechBannerActive(now: Date = new Date()): boolean {
  const end = new Date(VIVATECH_BANNER_END_ISO);
  return now.getTime() <= end.getTime();
}

export default function VivatechBanner() {
  const { t } = useTranslation();

  if (!isVivatechBannerActive()) return null;

  return (
    <div
      className="fixed left-0 right-0 top-16 z-40 h-20 text-white shadow-sm"
      style={{
        backgroundImage:
          'linear-gradient(90deg, #340067 0%, #5249e8 45%, #f49f00 100%)',
      }}
      role="region"
      aria-label={t('banner.vivatech.ariaLabel')}
    >
      <div className="mx-auto flex h-full max-w-7xl items-center gap-4 px-4 sm:px-6 lg:px-8">
        <div className="flex min-w-[200px] flex-col justify-center leading-none">
          <img
            src="/logos/vivatech-2026-white.png"
            alt="Vivatech"
            className="h-12 w-auto"
            loading="eager"
            decoding="async"
          />
        </div>

        <div className="flex min-w-0 flex-1 flex-col items-center font-semibold text-center">
          <div className="w-full truncate text-sm sm:text-base">
            {t('banner.vivatech.line1')}
          </div>
          <div className="w-full truncate text-sm opacity-95 sm:text-base">
            {t('banner.vivatech.line2')}
          </div>
        </div>

        <div className="hidden items-center gap-2 text-sm font-semibold sm:flex">
          <MapPin className="h-5 w-5 opacity-90" aria-hidden="true" />
          <div className="leading-tight">
            <div>{t('banner.vivatech.city')}</div>
            <div className="opacity-95">{t('banner.vivatech.venue')}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

